import { onBankAccountActivity } from "common/signalR";
import ActivityPanel from "components/ActivityPanel/ActivityPanel";
import React from "react";
import { BankAccountActivityCard } from "./BankAccountActivityCard";

interface Props {
  bankaccountId: number
  config: server.dto.ActivityPanelConfig
}

export const BankAccountActivityPanel = (props: Props) => {
  return <ActivityPanel<server.dto.BankAccountActivity>
    config={props.config}
    fetchActivities={(page, perPage) => window.CoreApi.BankAccount.ListActivity({ itemId: props.bankaccountId, page, perPage })}
    renderActivity={(activity => <BankAccountActivityCard key={activity.activityId} activity={activity} />)}
    onActivityRegisterFn={onBankAccountActivity}
    onActivity={(activity) => {
      if (activity.itemId !== props.bankaccountId) return { refreshActivities: false };

      const iAmActor = (activity.actor?.userId === site.currentUser.userId);

      return { refreshActivities: iAmActor };
    }}
  />
}